import Constants from '../Constants';
import * as Helpers from '../Utilities/Common';
import { normalizeData } from '../Schemas';
import { toggleModal, setModalData } from './ModalActions';


const { GET_LOCATIONS, LOCATIONS_LOADING, ADD_LOCATION, ADD_LOCATION_FAIL, DELETE_LOCATION, UPDATE_LOCATION, UPDATE_LOCATION_FAIL, ADD_SUBLOCATION, ADD_SUBLOCATION_FAIL, DELETE_SUBLOCATION, RESET_LOCATIONS_ALERT } = Constants;

export const getLocations = (token, newQuery = {}, append = true) => async ( dispatch, getState ) => {
    
    let query = { page: 1, per_page:15 };

    if(newQuery !== false){
        query = append ? { ...getState().typeStore.query, ...newQuery } : newQuery;
    }

    dispatch(locationLoading());

    const response = await Helpers.makeRequest(token,"LOCATIONS","GET","",query);
    if(response.result){
        const normalizedData = normalizeData(response.data,"locations");
        dispatch({ type: GET_LOCATIONS, payload: { data: normalizedData, query } });
        dispatch({ type: RESET_LOCATIONS_ALERT, payload: true });
    }
}

export const resetAlert = () => (dispatch) => {
    dispatch({ type: RESET_LOCATIONS_ALERT, payload: true });
}

export const locationLoading = () => ({ type: LOCATIONS_LOADING, payload: true });

export const deleteLocation = (token,id) => async (dispatch) => {

    const response = await Helpers.makeRequest(token,'LOCATIONS','DELETE','','',id);
    if(response.result){
        dispatch(setModalData("subLocations","display",{}));
        dispatch({ type: DELETE_LOCATION, payload: id });
    }
}

export const addLocation = (token,data,permissions) => async (dispatch) => {
    const { name } = data;
    let formData = { name };
    
    const response = await Helpers.makeRequest(token,'LOCATIONS','POST',formData);

    if(response.result){
        //dispatching action ADD_LOCATION causes the previous locations state to refresh
        dispatch({ type: ADD_LOCATION, payload: true });
        dispatch(toggleModal("locations","add"));
        dispatch(getLocations(token));
    }else{
        dispatch({ type: ADD_LOCATION_FAIL, payload: response.data });
    }
}

export const editLocation = (token, data, permissions, id) => async (dispatch) => {
    const { name } = data;
    let formData = { name };

    const response = await Helpers.makeRequest(token,'LOCATIONS','PUT',formData,'',id);
    if(response.result){
        dispatch({ type: UPDATE_LOCATION, payload: response.data.location });
        dispatch(toggleModal("locations","edit"));
        dispatch(resetAlert());
    }else{
        dispatch({ type: UPDATE_LOCATION_FAIL, payload: response.data });
    }
}

export const addSubLocation = (token,data,permissions,id = "") => async (dispatch) => {
    const { name, location_id } = data;
    let formData = { name };
    
    const response = await Helpers.makeRequest(token,'SUBLOCATIONS','POST',formData,'',location_id);

    if(response.result){
        const { sub_location: subLocation = {} } = response.data;
        //dispatching action ADD_LOCATION causes the previous locations state to refresh
        dispatch({ type: ADD_SUBLOCATION, payload: { subLocation, location_id } });
        dispatch(toggleModal("subLocations","add"));
        dispatch(resetAlert());

    }else{
        dispatch({ type: ADD_SUBLOCATION_FAIL, payload: response.data });
    }
}

export const deleteSubLocation = ( token,lid, id ) => async (dispatch) => {

    const response = await Helpers.makeRequest(token,'SUBLOCATIONS','DELETE','','',id);
    if(response.result){
        dispatch({type: DELETE_SUBLOCATION, payload: {id, location_id: lid}});
    }
}


// WEBPACK FOOTER //
// ./src/Actions/LocationActions.js